"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _systemFormConfig = require("@/api/systemFormConfig");
var _throttleDebounce = require("throttle-debounce");
var _permission = require("@/utils/permission");
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
var _systemSetting = require("@/api/systemSetting");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import creatProduct from './creatProduct'
// 权限判断函数
// 权限判断函数
var _default = {
  name: 'promptSoundSetting',
  data: function data() {
    return {
      listLoading: true,
      orList: ['admin_notice_mode_type'],
      countryAll: ['admin_notice_message'],
      countryList: [],
      pram: {},
      infoNum: {},
      isCreate: 0,
      tableData: {
        data: [],
        total: 0
      },
      myHeaders: {
        "X-Token": ""
      },
      currAutio: "",
      currentPlaying: null,
      // 当前正在播放的音频数据
      audioQueue: [],
      // 新增：用于存储待播放的音频数据
      isPlaying: false // 标记是否正在播放音频
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(param) {
        var formData, loading, res, nowIndex;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append("file", param.file);
              loading = this.$loading({
                lock: true,
                text: this.$t('uploadText'),
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              _context.next = 5;
              return (0, _systemSetting.fileupload)(formData);
            case 5:
              res = _context.sent;
              loading.close();
              this.$message.success(this.$t('uploadSuccess'));
              nowIndex = this.tableData.data.findIndex(function (item) {
                return item.remark == param.data.type;
              });
              this.tableData.data[nowIndex].value = res.file;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleUploadForm(_x) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    setName: function setName(item) {
      if (item.key == 'admin_notice_mode_type') {
        return this.$t(item.key);
      } else {
        return item.remark;
      }
    },
    listenNote: function listenNote(data) {
      if (data.value) {
        this.currAutio = data.value;
        var audioPlayer = this.$refs.audioPlayer;

        // 如果正在播放另一个音频，则先暂停它
        if (this.currentPlaying && this.currentPlaying !== data) {
          audioPlayer.pause();
          audioPlayer.src = ''; // 清空源以确保不会触发ended事件
        }

        // 更新当前播放的音频数据
        this.currentPlaying = data;

        // 设置新的音频源并加载
        audioPlayer.src = (0, _index.preFixxUrl)(this.currAutio);
        audioPlayer.load();

        // 根据状态播放或暂停音频
        if (data.isPlaying) {
          audioPlayer.pause();
        } else {
          audioPlayer.play().catch(function (error) {
            console.error('播放失败:', error);
          });
        }

        // 更新播放状态
        data.isPlaying = !data.isPlaying;
      } else {
        this.$message.warning("请先上传对应音频");
      }
    },
    onAudioEnded: function onAudioEnded() {
      // 当音频播放结束后执行的逻辑
      console.log('音频播放结束');

      // 可以在这里设置一些操作，比如更新UI或者准备下一个音频
      if (this.currentPlaying) {
        this.currentPlaying.isPlaying = false; // 让按钮回到“播放”状态
      }
    },
    deleteItem: function deleteItem(data, index) {
      var _this = this;
      if (data.id) {
        (0, _infoMessage.deleteSystemConfig)({
          id: data.id
        }).then(function () {
          _this.$message.success(_this.$t('sccg'));
          _this.getList();
        });
      } else {
        this.czljjeList.splice(index, 1);
      }
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _infoMessage.getAdminNoticeConfig)().then(function (res) {
        _this2.tableData.data = res.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            isPlaying: false // 初始化播放状态
          });
        });

        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      this.listLoading = true;
      var data = {
        config_list: this.tableData.data.map(function (item) {
          var id = item.id,
            remark = item.remark,
            value = item.value,
            key = item.key,
            condition = item.condition,
            status = item.status;
          return {
            id: id,
            remark: remark,
            value: _this3.countryAll.includes(key) ? value.toString() : value,
            key: key,
            condition: condition,
            status: status
          };
        })
      };
      var isCreate = sessionStorage.getItem('isCreate');
      (0, _infoMessage.saveSystemConfig)(data).then(function (res) {
        _this3.$message.success(_this3.$t('xgcg'));
        _this3.getList();
        sessionStorage.removeItem('currTime');
        _this3.getNoteNum();
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    getNoteNum: function () {
      var _getNoteNum = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _systemFormConfig.getAdminSystemMessageNumber)();
            case 2:
              res = _context2.sent;
              this.infoNum = res;
              this.getNoteList();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getNoteNum() {
        return _getNoteNum.apply(this, arguments);
      }
      return getNoteNum;
    }(),
    getNoteList: function () {
      var _getNoteList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var allData, nowIndex, oldTime;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _infoMessage.getAdminNoticeConfig)();
            case 2:
              allData = _context3.sent;
              nowIndex = allData.findIndex(function (item) {
                return item.key == 'admin_notice_mode_type';
              }); // 配置模式
              if (nowIndex != -1) {
                oldTime = sessionStorage.getItem('currTime');
                if (allData[nowIndex].value == 2) {
                  if (new Date().getTime() > oldTime) {
                    sessionStorage.setItem('currTime', new Date().getTime() + 50000);
                    this.noteSys(allData);
                  }
                } else {
                  if (oldTime != new Date(this.infoNum.last_time).getTime()) {
                    sessionStorage.setItem('currTime', new Date(this.infoNum.last_time).getTime());
                    this.noteSys(allData);
                  }
                }
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getNoteList() {
        return _getNoteList.apply(this, arguments);
      }
      return getNoteList;
    }(),
    noteSys: function noteSys(allData) {
      var noteList = allData.filter(function (item) {
        return item.key == 'admin_notice_message';
      });

      // 初始化 isPlaying 属性
      allData.forEach(function (item) {
        item.isPlaying = false;
      });
      if (this.infoNum.recharge_number > 0 && noteList.length > 0) {
        this.enqueueAudio(this.setTetx(noteList[0]));
      }
      if (this.infoNum.withdraw_number > 0 && noteList.length > 1) {
        var data = this.setTetx(noteList[1]);
        if (data) this.enqueueAudio(data);
      }
      if (this.infoNum.auth_number > 0 && noteList.length > 2) {
        this.enqueueAudio(this.setTetx(noteList[2]));
      }
      if (this.infoNum.order_number > 0 && noteList.length > 3) {
        this.enqueueAudio(this.setTetx(noteList[3]));
      }

      // 如果没有音频正在播放，则开始播放队列中的第一个音频
      if (!this.isPlaying && this.audioQueue.length > 0) {
        this.dequeueAndPlay();
      }
    },
    enqueueAudio: function enqueueAudio(data) {
      if (data) {
        this.audioQueue.push(data);
      }
    },
    dequeueAndPlay: function dequeueAndPlay() {
      if (this.audioQueue.length === 0) {
        this.isPlaying = false;
        return;
      }
      var nextAudio = this.audioQueue.shift();
      this.updateListNote(nextAudio);
    },
    setTetx: function setTetx(data) {
      return data.status == 0 ? null : data;
    },
    updateListNote: function updateListNote(data) {
      var _this4 = this;
      if (!data.value) {
        // 如果没有音频文件，则尝试使用 speech 合成
        speech.speak({
          text: data.remark
        }).catch(function (e) {
          return console.error('语音播报失败:', e);
        });
        this.dequeueAndPlay(); // 完成后继续播放下一个音频
        return;
      }
      var audioPlayer = this.$refs.audioPlayerAL;
      if (!audioPlayer) {
        console.error("Audio player element is not available.");
        this.dequeueAndPlay(); // 出错后继续播放下一个音频
        return;
      }

      // 更新当前播放的音频数据
      this.currentPlaying = data;
      this.isPlaying = true; // 设置为正在播放状态

      // 设置新的音频源并加载
      audioPlayer.src = (0, _index.preFixxUrl)(data.value); // 使用 data.value 而不是 this.currAutio
      audioPlayer.load();
      audioPlayer.addEventListener('ended', function () {
        _this4.isPlaying = false;
        data.isPlaying = false;
        _this4.dequeueAndPlay(); // 音频播放结束，继续播放下一个音频
      }, {
        once: true
      });
      if (!data.isPlaying) {
        audioPlayer.play().then(function () {
          data.isPlaying = true;
        }).catch(function (error) {
          _this4.isPlaying = false;
          data.isPlaying = false;
          _this4.dequeueAndPlay(); // 播放失败后继续播放下一个音频
        });
      }
    }
  }
};
exports.default = _default;